import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { clearOfflineData } from "../lib/pwa";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      })
      .finally(() => setLoading(false));
  }, []);

  const deviceId = () => {
    try {
      let d = localStorage.getItem("sp_device_id");
      if (!d) { d = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)); localStorage.setItem("sp_device_id", d); }
      return d;
    } catch { return ""; }
  };

  const login = async (email, password, phone = "", otp = "") => {
    try {
      const { data } = await api.post("/auth/login", { email, password, phone, otp, device_id: deviceId() });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      const d428 = e.response?.status === 428;
      const isOtp = d428 && e.response?.data?.detail === "otp_required";
      return { ok: false, needOtp: isOtp, needPhone: d428 && !isOtp, error: isOtp ? "Doğrulama kodunu girin" : formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearOfflineData();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
